'use client';

import { Toaster } from 'sonner';

export function AppToaster() {
  return <Toaster theme="dark" position="bottom-right" richColors closeButton />;
}

export { toast } from 'sonner';
